import { render, staticRenderFns } from "./clientSetup.vue?vue&type=template&id=5c8a5848&scoped=true&"
import script from "./clientSetup.vue?vue&type=script&lang=js&"
export * from "./clientSetup.vue?vue&type=script&lang=js&"
import style0 from "./clientSetup.vue?vue&type=style&index=0&id=5c8a5848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a5848",
  null
  
)

export default component.exports